(function () {
  'use strict';

  if (window.LuluLocalBundleContents) {
    window.LuluLocalBundleContents.init(document);
    return;
  }

  var warnedDiagnostics = Object.create(null);
  var REQUEST_TIMEOUT_MS = 8000;
  var STOREFRONT_API_PATH = '/api/2026-07/graphql.json';
  var QUERY =
    'query($id:ID!){node(id:$id){... on ProductVariant{' +
    'requiresComponents components(first:50){nodes{quantity productVariant{' +
    'title image{url altText} product{title handle featuredImage{url altText}}}}}}}}';

  function esc(value) {
    var element = document.createElement('div');
    element.textContent = value == null ? '' : String(value);
    return element.innerHTML;
  }

  function escAttr(value) {
    return esc(value).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function sizedImage(url, width) {
    if (!url) return '';
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'width=' + width;
  }

  function thumb(image, size, fallbackAlt) {
    if (!image || !image.url || size <= 0) return '';
    var src = sizedImage(image.url, size * 2);
    var alt = image.altText || fallbackAlt || '';
    return '<img class="bundle-contents__thumb" src="' + escAttr(src) + '" alt="' + escAttr(alt) + '" loading="lazy">';
  }

  function preview(componentData) {
    var previewLimit = 4;
    var html = componentData.slice(0, previewLimit).map(function (component) {
      var content = component.thumbnail && component.thumbnail.url
        ? '<img class="bundle-contents__preview-image" src="' +
          escAttr(sizedImage(component.thumbnail.url, 64)) + '" alt="" loading="lazy">'
        : '<span class="bundle-contents__preview-initial">' +
          esc(String(component.title || '').trim().charAt(0) || '?') + '</span>';
      return '<span class="bundle-contents__preview-item">' + content + '</span>';
    }).join('');

    if (componentData.length > previewLimit) {
      html += '<span class="bundle-contents__preview-item bundle-contents__preview-more">+' +
        (componentData.length - previewLimit) + '</span>';
    }
    return html;
  }

  function resetDialog(dialog) {
    if (!dialog) return;
    var media = dialog.querySelector('[data-bundle-contents-dialog-media]');
    var image = dialog.querySelector('[data-bundle-contents-dialog-image]');
    var title = dialog.querySelector('[data-bundle-contents-dialog-title]');
    if (media) media.hidden = true;
    if (image) {
      image.removeAttribute('src');
      image.alt = '';
    }
    if (title) title.textContent = '';
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    var trigger = dialog._bundleContentsTrigger;
    dialog._bundleContentsTrigger = null;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    resetDialog(dialog);
    if (trigger && document.contains(trigger)) trigger.focus();
  }

  function ensureDialog() {
    var dialog = document.querySelector('[data-bundle-contents-dialog]');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'bundle-contents__dialog';
    dialog.setAttribute('data-bundle-contents-dialog', '');
    dialog.setAttribute('aria-labelledby', 'bundle-contents-dialog-title');
    dialog.innerHTML =
      '<button type="button" class="bundle-contents__dialog-close" data-bundle-contents-close aria-label="Close product details">' +
      '<svg class="at-icon" width="18" height="18" aria-hidden="true"><use xlink:href="#icon-close"></use></svg>' +
      '</button>' +
      '<div class="bundle-contents__dialog-layout">' +
      '<div class="bundle-contents__dialog-media" data-bundle-contents-dialog-media>' +
      '<img class="bundle-contents__dialog-image" data-bundle-contents-dialog-image alt="" width="900" height="900">' +
      '</div>' +
      '<div class="bundle-contents__dialog-content">' +
      '<h3 class="bundle-contents__dialog-title" id="bundle-contents-dialog-title" data-bundle-contents-dialog-title></h3>' +
      '</div></div>';
    document.body.appendChild(dialog);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-bundle-contents-close]')) {
        closeDialog(dialog);
      }
    });
    dialog.addEventListener('close', function () {
      var trigger = dialog._bundleContentsTrigger;
      dialog._bundleContentsTrigger = null;
      resetDialog(dialog);
      if (trigger && document.contains(trigger)) trigger.focus();
    });
    return dialog;
  }

  function openComponentDialog(element, index, trigger) {
    var component = element._bundleContentsComponents && element._bundleContentsComponents[index];
    if (!component) return;
    var dialog = ensureDialog();
    resetDialog(dialog);
    var media = dialog.querySelector('[data-bundle-contents-dialog-media]');
    var image = dialog.querySelector('[data-bundle-contents-dialog-image]');
    var title = dialog.querySelector('[data-bundle-contents-dialog-title]');

    title.textContent = component.title;
    media.hidden = !component.imageUrl;
    if (component.imageUrl) {
      image.src = sizedImage(component.imageUrl, 1200);
      image.alt = component.imageAlt || component.title;
    } else {
      image.removeAttribute('src');
      image.alt = '';
    }

    dialog._bundleContentsTrigger = trigger;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', 'open');
  }

  function handleBundleClick(event) {
    var trigger = event.target.closest('[data-bundle-component-index]');
    if (!trigger || !event.currentTarget.contains(trigger)) return;
    openComponentDialog(
      event.currentTarget,
      Number(trigger.getAttribute('data-bundle-component-index')),
      trigger
    );
  }

  function clearBundle(element) {
    var list = element.querySelector('.bundle-contents__list');
    var previewElement = element.querySelector('[data-bundle-contents-preview]');
    var count = element.querySelector('[data-bundle-contents-count]');
    if (list) list.innerHTML = '';
    if (previewElement) previewElement.innerHTML = '';
    if (count) count.textContent = '';
    element._bundleContentsComponents = [];
    element.classList.remove('is-loaded');
  }

  function setStatus(element, status, errorCode) {
    element.setAttribute('data-bundle-contents-status', status);
    element.setAttribute('aria-busy', status === 'loading' ? 'true' : 'false');
    if (errorCode) element.setAttribute('data-bundle-contents-error', errorCode);
    else element.removeAttribute('data-bundle-contents-error');
  }

  function failBundle(element, code, message, detail) {
    clearBundle(element);
    setStatus(element, 'error', code);
    if (!warnedDiagnostics[code] && window.console && typeof window.console.warn === 'function') {
      warnedDiagnostics[code] = true;
      window.console.warn('[LuluLocal bundle contents] ' + message, detail || '');
    }
  }

  function storefrontAccessToken() {
    var data = document.querySelector('[data-ll-bundle-product-data]');
    return data ? data.getAttribute('data-ll-storefront-access-token') || '' : '';
  }

  function hiddenProductHandles(element) {
    var value = element.getAttribute('data-hidden-products');
    if (!value) return [];
    try {
      var handles = JSON.parse(value);
      if (!Array.isArray(handles)) return [];
      return handles
        .filter(function (handle) { return typeof handle === 'string' && handle; })
        .map(function (handle) { return handle.toLowerCase(); });
    } catch (_error) {
      return [];
    }
  }

  async function loadBundle(element, requestedVariantId) {
    var variantId = String(
      requestedVariantId || element.getAttribute('data-variant-id') || ''
    ).replace(/\D/g, '');
    if (!variantId) {
      clearBundle(element);
      setStatus(element, 'idle', '');
      return;
    }

    element.setAttribute('data-variant-id', variantId);
    var requestId = String((parseInt(element.getAttribute('data-request-id'), 10) || 0) + 1);
    element.setAttribute('data-request-id', requestId);
    clearBundle(element);
    setStatus(element, 'loading', '');

    var token = storefrontAccessToken();
    if (!token) {
      failBundle(
        element,
        'missing-storefront-token',
        'The Bundle product data app embed is missing or has no Storefront token.'
      );
      return;
    }

    var imageSize = parseInt(getComputedStyle(element).getPropertyValue('--bc-img'), 10);
    if (!Number.isFinite(imageSize)) imageSize = 56;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var didTimeout = false;
    var timeoutId = window.setTimeout(function () {
      didTimeout = true;
      if (controller) controller.abort();
    }, REQUEST_TIMEOUT_MS);

    try {
      var response = await fetch(STOREFRONT_API_PATH, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({
          query: QUERY,
          variables: { id: 'gid://shopify/ProductVariant/' + variantId },
        }),
        signal: controller ? controller.signal : undefined,
      });
      if (element.getAttribute('data-request-id') !== requestId) return;
      if (!response.ok) {
        failBundle(
          element,
          'storefront-http-error',
          'The Storefront API returned HTTP ' + response.status + '.'
        );
        return;
      }

      var payload = await response.json();
      if (element.getAttribute('data-request-id') !== requestId) return;
      if (Array.isArray(payload.errors) && payload.errors.length > 0) {
        failBundle(
          element,
          'storefront-graphql-error',
          'The Storefront API returned a GraphQL error.',
          payload.errors
        );
        return;
      }

      var variant = payload && payload.data && payload.data.node;
      var components = variant && variant.components && variant.components.nodes;
      if (!variant || !variant.requiresComponents || !Array.isArray(components) || components.length === 0) {
        clearBundle(element);
        setStatus(element, 'not-bundle', '');
        return;
      }

      var hiddenProducts = hiddenProductHandles(element);
      var componentData = components.map(function (component) {
        var variantData = component && component.productVariant;
        var product = variantData && variantData.product;
        if (!variantData || !product) return null;
        if (hiddenProducts.indexOf(String(product.handle || '').toLowerCase()) !== -1) return null;
        var name = product.title
          + (variantData.title && variantData.title !== 'Default Title' ? ' – ' + variantData.title : '');
        var quantity = Math.max(1, Number(component.quantity) || 1);
        var image = variantData.image && variantData.image.url
          ? variantData.image
          : product.featuredImage;
        return {
          title: name,
          quantity: quantity,
          imageUrl: image && image.url ? image.url : '',
          imageAlt: image && image.altText ? image.altText : name,
          thumbnail: image,
        };
      }).filter(Boolean);
      element._bundleContentsComponents = componentData;
      var html = componentData.map(function (component, index) {
        return (
          '<li class="bundle-contents__item"><button type="button" class="bundle-contents__item-button" ' +
          'data-bundle-component-index="' + index + '" aria-haspopup="dialog">' +
          thumb(component.thumbnail, imageSize, component.title) +
          '<span class="bundle-contents__meta"><span class="bundle-contents__name">' +
          esc(component.title) +
          '<span class="bundle-contents__qty" aria-label="Quantity ' + component.quantity + '">×' + component.quantity + '</span>' +
          '</span></span></button></li>'
        );
      }).join('');

      if (!html) {
        clearBundle(element);
        setStatus(element, 'not-bundle', '');
        return;
      }

      var list = element.querySelector('.bundle-contents__list');
      var previewElement = element.querySelector('[data-bundle-contents-preview]');
      var count = element.querySelector('[data-bundle-contents-count]');
      if (list) list.innerHTML = html;
      if (previewElement) previewElement.innerHTML = preview(componentData);
      if (count) count.textContent = ' (' + componentData.length + ')';
      element.classList.add('is-loaded');
      setStatus(element, 'loaded', '');
    } catch (error) {
      if (element.getAttribute('data-request-id') !== requestId) return;
      if (didTimeout || (error && error.name === 'AbortError')) {
        failBundle(
          element,
          'storefront-timeout',
          'The Storefront API bundle request timed out after ' + REQUEST_TIMEOUT_MS + 'ms.'
        );
      } else {
        failBundle(
          element,
          'storefront-request-error',
          'The Storefront API bundle request failed.',
          error
        );
      }
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  function elementsWithin(root) {
    var elements = [];
    if (root && root.nodeType === Node.ELEMENT_NODE && root.matches('[data-bundle-contents]')) {
      elements.push(root);
    }
    if (root && typeof root.querySelectorAll === 'function') {
      elements = elements.concat(Array.from(root.querySelectorAll('[data-bundle-contents]')));
    }
    return elements;
  }

  function init(root) {
    elementsWithin(root || document).forEach(function (element) {
      if (element.getAttribute('data-bundle-contents-initialized') === 'true') return;
      element.setAttribute('data-bundle-contents-initialized', 'true');
      element.addEventListener('click', handleBundleClick);
      loadBundle(element);
    });
  }

  function subscribeToVariantChanges() {
    if (
      typeof window.subscribe !== 'function' ||
      typeof window.PUB_SUB_EVENTS === 'undefined' ||
      !window.PUB_SUB_EVENTS.variantChange
    ) return;

    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      var variant = data && data.variant;
      if (!variant || !variant.id) return;

      document.querySelectorAll('[data-bundle-contents]').forEach(function (element) {
        if (data.sectionId && element.getAttribute('data-section-id') !== String(data.sectionId)) return;
        loadBundle(element, variant.id);
      });
    });
  }

  window.LuluLocalBundleContents = Object.freeze({ init: init, load: loadBundle });

  function boot() {
    init(document);
    subscribeToVariantChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
